import React, { useEffect, useState } from 'react';
import logo from '../assets/logo-narayan.png';
import { useAuth } from '../context/AuthContext';
import { FullScreen } from './ui';
import Notifications from '../screens/Notifications';
import api from '../api/client';

/**
 * Desktop navigation rail. Replaces the floating bottom tab bar from 900px up,
 * where a persistent, labelled nav is both usable and expected.
 */
export default function Sidebar({ tabs, activePath, onNavigate }) {
  const { user, logout } = useAuth();
  const [unread, setUnread] = useState(0);
  const [notifOpen, setNotifOpen] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get('/notifications')
      .then((d) => { if (alive) setUnread(d?.unread || 0); })
      .catch(() => {});
    return () => { alive = false; };
  }, [notifOpen]);

  const avatar = user?.profilePhoto || user?.kyc?.selfieImage;
  const isStaff = user?.role === 'staff';

  return (
    <>
      <aside className="sidebar">
        <div className="sidebar__brand">
          <img src={logo} alt="Narayan Home Facility Services" />
        </div>

        <nav className="sidebar__nav" aria-label="Main">
          {tabs.map((t) => (
            <button
              key={t.key}
              className={`navitem ${activePath === t.path ? 'navitem--active' : ''}`}
              onClick={() => onNavigate(t.path)}
              aria-current={activePath === t.path ? 'page' : undefined}
            >
              <span className="navitem__icon">{t.icon}</span>
              <span className="navitem__label">{t.label}</span>
            </button>
          ))}

          <button className="navitem" onClick={() => setNotifOpen(true)}>
            <span className="navitem__icon">🔔</span>
            <span className="navitem__label">Notifications</span>
            {unread > 0 && <span className="navitem__badge">{unread > 9 ? '9+' : unread}</span>}
          </button>
        </nav>

        <div className="sidebar__foot">
          <div className="sidebar__user">
            <span className="avatar" style={{ width: 38, height: 38, fontSize: 14 }}>
              {avatar ? <img src={avatar} alt="" /> : (user?.name || user?.mobile || 'U').charAt(0).toUpperCase()}
            </span>
            <span className="grow" style={{ minWidth: 0 }}>
              <span className="sidebar__name">{user?.name || 'Welcome'}</span>
              <span className="sidebar__role">{isStaff ? 'Service Provider' : 'Customer'}</span>
            </span>
          </div>
          <button className="sidebar__logout" onClick={logout}>Logout</button>
        </div>
      </aside>

      <FullScreen open={notifOpen} onClose={() => setNotifOpen(false)} variant="panel">
        <Notifications onClose={() => setNotifOpen(false)} />
      </FullScreen>
    </>
  );
}
